import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApplyV2Config } from './apply-v2-config';

@NgModule({
  imports: [CommonModule],
})
export class ApplyV2ConfigModule {
  static forRoot(
    config: ApplyV2Config
  ): ModuleWithProviders<ApplyV2ConfigModule> {
    return {
      ngModule: ApplyV2ConfigModule,
      providers: [
        {
          provide: ApplyV2Config,
          useValue: config,
        },
      ],
    };
  }
}
